import { render } from "./UserImagePlaceholder.vue?vue&type=template&id=8b5a5050&scoped=true"
import script from "./UserImagePlaceholder.vue?vue&type=script&lang=js"
export * from "./UserImagePlaceholder.vue?vue&type=script&lang=js"

import "./UserImagePlaceholder.vue?vue&type=style&index=0&id=8b5a5050&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b5a5050"],['__file',"src/scripts/common/components/UserImagePlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b5a5050"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b5a5050', __exports__)) {
    api.reload('8b5a5050', __exports__)
  }
  
  module.hot.accept("./UserImagePlaceholder.vue?vue&type=template&id=8b5a5050&scoped=true", () => {
    api.rerender('8b5a5050', render)
  })

}


export default __exports__